module.exports = __webpack_public_path__ + "static/img/very_good_selected.1bead5e2.png";